import { CopyOutlined } from "@ant-design/icons";
import {  Typography } from "antd";
import { copyToclipBoard } from "utils";

interface TransactionFieldProps {
  icon: React.ReactNode;
  label: string;
  value: string | null;
  copyable?: boolean;
}
const { Text } = Typography;

export function TransactionField({
  icon,
  label,
  value,
  copyable = false,
}: TransactionFieldProps) {
  return (
    <div className="transaction-field">
    <div className="field-icon">{icon}</div>
    <div className="field-label">
      <Text className="label-text">{label}</Text>
    </div>
    <div className="field-value">
      <Text className="value-text">{value}</Text>
      {copyable && value && (
        <div className="field-actions">
          <button className="action-btn" onClick={() => copyToclipBoard(value)}>
            <CopyOutlined />
          </button>

        </div>
      )}
    </div>
  </div>
  );
}
